import React, { Component } from 'react';
import { Icon } from './Icon';
import PropTypes from 'prop-types';

import styles from './sidebar/sidebar.module.scss';

export class Sidebar extends Component {
  timer = null
  zoom = 100

  componentDidMount() {
    window.addEventListener('resize', this.toggleSidebarOnResize);
    this.toggleSidebarOnResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.toggleSidebarOnResize);
  }

  changeZoom = (width) => {
    if (!this.timer) {
      clearTimeout(this.timer);
    }

    if (width > 1280) {
      if (this.zoom !== 100) {
        this.zoom = 100;
        document.body.style.zoom = '100%';
      }
      return;
    }

    const rawZoom = (width / 1280) * 100;
    const zoom = Math.min(parseInt(rawZoom) || 100, 100);

    this.timer = setTimeout(() => {
      this.zoom = zoom;
      document.body.style.zoom = `${parseInt(zoom) || 100}%`;
    }, 800);
  }

  toggleSidebarOnResize = () => {
    const { toggleSidebar, zoomOnResize } = this.props;
    const width = window.innerWidth;

    if (zoomOnResize && (width > 959 && width < 1281)) {
      this.changeZoom(window.innerWidth);
    } else {
      if (this.windowWidth === undefined) {
        this.windowWidth = window.innerWidth;

        if (this.windowWidth < 1280) {
          toggleSidebar(false);
        }
      } else {
        if (this.windowWidth < 1280) {
          this.windowWidth = window.innerWidth;
        } else {
          if (window.innerWidth < 1280) {
            this.windowWidth = window.innerWidth;
            this.props.isOpen && toggleSidebar(false);
          }
        }
      }
    }
  }

  render() {
    const {
      className = '',
      arrowClassName = '',
      isOpen = true,
      toggleSidebar,
      children,
      getRef,
    } = this.props;

    return (
      <aside
        ref={getRef}
        className={`${styles.sidebar} ${isOpen ? '_is-open' : '_is-closed'} ${className}`}
      >
        {children}
        <div className={`${styles.wrapper} ${arrowClassName}`} onClick={toggleSidebar}>
          <div className={styles.arrow}>
            <i className={styles.icon}>
              <Icon name="Left" />
            </i>
            <span className={styles.title}>
              {isOpen ? 'Hide' : 'Show'}
            </span>
          </div>
        </div>
      </aside>
    );
  }
}

Sidebar.propTypes = {
  className: PropTypes.string,
  arrowClassName: PropTypes.string,
  isOpen: PropTypes.bool,
  toggleSidebar: PropTypes.func,
  getRef: PropTypes.func,
  zoomOnResize: PropTypes.bool,
};
